import { Avatar, Skeleton, theme } from 'antd';
import React, { type ReactNode, useMemo } from 'react';
import { type AuthSession } from '../types';

const UserAvatar = (props: { session?: AuthSession }): ReactNode => {
  const { token } = theme.useToken();
  const { session } = props;
  const letters = useMemo(() => {
    const firstName = session?.claims.firstName ?? '';
    const lastName = session?.claims.lastName ?? '';
    const avatarLetters =
      (firstName?.length > 0 ? firstName[0].toUpperCase() : '') +
      (lastName?.length > 0 ? lastName[0].toUpperCase() : '');
    if (avatarLetters.trim().length === 0) {
      return 'C';
    }
    return avatarLetters;
  }, [session]);

  return letters.length === 0 ? (
    <Skeleton.Avatar active />
  ) : (
    <Avatar
      style={{
        color: token.colorPrimary,
        background: token.colorBgContainer,
      }}
    >
      {letters}
    </Avatar>
  );
};

export default UserAvatar;
